export const defaultStyle = {
    display: "block",
    width: "fit-content",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
};
